import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateAsAgo',
  pure: true
})
export class DateAsAgoPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (value) {
      const localDate = new Date(value + 'Z');
      const seconds = Math.floor((+new Date() - +localDate) / 1000);

      if (seconds < 29) // less than 30 seconds ago will show as 'Just now'
        return 'Just now';
      const intervals: { [key: string]: number } = {
        'Y': 31536000,
        'M': 2592000,
        'W': 604800,
        'D': 86400,
        'h': 3600,
        'm': 60,
        's': 1
      };
      let counter;
      for (const i in intervals) {
        counter = Math.floor(seconds / intervals[i]);
        if (counter > 0)
          return counter + ' ' + i + ' '; // singular (1 day ago)
        // if (counter === 1) {
        // }
        //  else {
        //   return counter + ' ' + i + 's ago'; // plural (2 days ago)
        // }
      }
    }
    return value;
  }
}
